package dev.akshaychordiya.content

/**
 * An app published on Google Play.
 *
 * @param packageId Used to build the store URL, so there's no second copy of the link to keep in sync.
 * @param iconSlug Basename of the icon in `public/images/apps/`. The icons are the real store artwork, downloaded
 *   at 256px rather than hotlinked from Google's CDN so the site doesn't break if those URLs rotate.
 * @param note Optional aside - a companion relationship, or that something is a paid unlock.
 */
class App(
    val name: String,
    val tagline: String,
    val packageId: String,
    val iconSlug: String,
    val note: String = "",
) {
    val storeUrl: String get() = "https://play.google.com/store/apps/details?id=$packageId"
    val iconUrl: String get() = "/images/apps/$iconSlug.webp"
}

/**
 * Indie apps on Google Play.
 *
 * Names and package ids come from the developer page; the taglines are written for this site rather than lifted from
 * the store listings, so tighten any that don't sound like you.
 */
val apps = listOf(
    App(
        name = "Catnip",
        tagline = "Map the neighbourhood cats you meet.",
        packageId = "com.aj.catmapper",
        iconSlug = "catnip",
    ),
    App(
        name = "Jair Music Player",
        tagline = "A local music player built around getting out of the way - your library, played simply.",
        packageId = "aj.jair.music",
        iconSlug = "jair-music",
    ),
    App(
        name = "Automaton Locker",
        tagline = "A smarter lock screen that learns when it doesn't need to bother you.",
        packageId = "aky.akshay.coveralgorithm",
        iconSlug = "automaton-locker",
    ),
    App(
        name = "Automaton Unlocker",
        tagline = "The paid unlock for Automaton Locker.",
        packageId = "aky.akshay.coveralgorithm.unlock",
        iconSlug = "automaton-unlocker",
        note = "Companion to Automaton Locker",
    ),
    App(
        name = "Pronouncer",
        tagline = "Hear how a word is actually said, without wading through a dictionary app.",
        packageId = "com.pronouncer.app",
        iconSlug = "pronouncer",
    ),
)

const val PLAY_DEVELOPER_URL = "https://play.google.com/store/apps/developer?id=Akshay+Chordiya"
